import React from 'react';
import { Gift, ArrowRight, CheckCircle } from 'lucide-react';
interface Offer {
  title: string;
  description: string;
  value: string;
  included: string[];
}
interface CTASlideProps {
  content: {
    offers: Offer[];
    nextSteps: string[];
  };
}
export function CTASlide({
  content
}: CTASlideProps) {
  return <div className="bg-gradient-to-br from-[#1C1C1C] to-[#017C6D] rounded-2xl p-12" data-id="element-97">
      <div className="text-center mb-12" data-id="element-98">
        <h2 className="text-5xl font-bold text-white mb-4" data-id="element-99">
          Ready to Transform Your Response Strategy?
        </h2>
        <p className="text-2xl text-white/90" data-id="element-100">
          Exclusive offers for webinar attendees
        </p>
      </div>

      <div className="grid grid-cols-3 gap-6 mb-12" data-id="element-101">
        {content.offers.map((offer, index) => <div key={index} className="bg-white rounded-xl p-8" data-id="element-102">
            <div className="flex items-center gap-3 mb-4" data-id="element-103">
              <Gift className="text-[#0FB07D]" size={32} data-id="element-104" />
              <div className="text-sm font-bold text-[#0FB07D] bg-[#0FB07D]/10 px-3 py-1 rounded-full" data-id="element-105">
                {offer.value}
              </div>
            </div>
            <h3 className="text-2xl font-bold text-[#1C1C1C] mb-3" data-id="element-106">
              {offer.title}
            </h3>
            <p className="text-[#4D4D4D] mb-6" data-id="element-107">{offer.description}</p>

            <div className="space-y-2" data-id="element-108">
              {offer.included.map((item, idx) => <div key={idx} className="flex items-start gap-2" data-id="element-109">
                  <CheckCircle size={18} className="text-[#0FB07D] mt-0.5 flex-shrink-0" data-id="element-110" />
                  <span className="text-sm text-[#4D4D4D]" data-id="element-111">{item}</span>
                </div>)}
            </div>
          </div>)}
      </div>

      <div className="bg-white/10 backdrop-blur rounded-xl p-8 border border-white/20" data-id="element-112">
        <h3 className="text-2xl font-bold text-white mb-6 text-center" data-id="element-113">
          Next Steps
        </h3>
        <div className="grid grid-cols-2 gap-4" data-id="element-114">
          {content.nextSteps.map((step, index) => <div key={index} className="flex items-center gap-3 text-white text-lg" data-id="element-115">
              <ArrowRight className="text-[#0FB07D] flex-shrink-0" size={24} data-id="element-116" />
              <span data-id="element-117">{step}</span>
            </div>)}
        </div>

        <div className="mt-8 text-center" data-id="element-118">
          <button className="bg-[#0FB07D] text-white px-12 py-4 rounded-lg text-xl font-bold hover:bg-[#017C6D] transition-colors" data-id="element-119">
            Book Your Free Strategy Session
          </button>
        </div>
      </div>
    </div>;
}
export default CTASlide;